<template>
    <div :style="{paddingTop: !hasInitedCustomer ? '0' : formPaddingTop}">
        <div v-if="isPreparing && !isUser" class="preparing-page-container p-4">
            <div class="preparing-page-logo">
                <img v-if="context.logoContentUnit"  :src="context.storageEndpoint + context.logoContentUnit.file_name" width="64"/>
            </div>
            <div class="mt-2">
                <p>{{ $t('message.landing_page_is_preparing') }}</p>
            </div>
        </div>
        <div v-else-if="!hasInitedCustomer"></div>
        <div v-else>
            <!-- Top Bar -->
            <div class="top-bar-container px-4 py-2" ref="topBarContainer">
                <div>
                    <top-bar-customer-section
                        :context="context"
                        :provider="provider" scrollElementClass="booking-container" />

                    <!-- Service & Member Select -->
                    <top-service-select v-if="openTopServiceSelect" ref="topServiceSelect"
                        @service-selected="(service) => this.selectedService = service"
                        @member-selected="onMemberSelected" :preselected-service="selectedService"
                        :preselected-member="selectedMember" :context="context"
                        class="text-dark top-service-select d-inline-block align-bottom" :provider="provider" />

                    <!-- Date Picker -->
                    <div class="d-none d-md-inline-flex align-bottom" v-if="!hasPresetInBookingPass && selectedService && selectedMember && !isPreviewingService(selectedService)">
                        <div class="ml-2">
                            <div class="pl-2 field-label">{{provider.landing_choose_time_label || $t('general.datetime_to_booking')}}</div>
                            <available-date-time-picker
                                ref="availableDateTimePicker"
                                :overwritePlaceholder="startDateTimePickerPlaceholder"
                                cy-top-avaialble-date-time-picker
                                input-class="availability-calendar-input-class" class="flex-grow-1 mx-2" v-model="selectedDate"
                                :check-cart-items="true"
                                :service="selectedService" :member="selectedMember" :provider="provider" :context="context"
                                :fixed-time="selectedService ? selectedService.start_time : null" />
                        </div>
                        <div v-if="selectedService && selectedService.allow_custom_duration && selectedDate">
                            <div class="pl-2 field-label">{{provider.landing_choose_end_time_label || $t('general.booking_end_datetime')}}</div>
                            <available-date-time-picker
                                ref="availableEndDateTimePicker"
                                :extraAvailabilityCheck="isTimeslotAvailableForEndDate"
                                :ignore-service-start-time="true"
                                :check-cart-items="true"
                                :overwritePlaceholder="$t('message.select_custom', {custom: (provider.landing_choose_end_time_label || $t('general.booking_end_datetime'))})"
                                input-class="availability-calendar-input-class"
                                class="flex-grow-1 mx-2"
                                v-model="selectedEndDate"
                                :cross-over-disabled="true"
                                :start-moment="selectedDateMoment"
                                :fixed-time="selectedService.custom_duration_fixed_endtime"
                                :service="selectedService"
                                :member="selectedMember"
                                :provider="provider"
                                :context="context" />
                        </div>
                    </div>
                </div>
                <form-section-controller
                    :formPaddingTop="formPaddingTop"
                    :style="{position: 'relative', top: '6px', marginTop: '8px'}"
                    ref="form-sections-controller"/>
            </div>

            <div class="flex-grow-1 service-select-hint" v-if="openTopServiceSelect && !selectedService">
                {{$t('message.please_select_service')}}</div>

            <new-booking-form
                v-if="selectedService"
                class="booking-form"
                ref="booking-form"
                :service="selectedService"
                :memberUser="selectedMember"
                :context="context"
                :provider="provider"
                :date="selectedDate"
                :endDateTime="selectedEndDate"
                @toggleIsLoadingQuestions="onToggleIsLoadingQuestions"
                @requestFocusToDateSelect="openDatePicker"
                @requestFocusToEndDateSelect="openEndDatePicker"
                @booked="gaTrackBooked()"
                :form-padding-top="formPaddingTop"
            />
            <div v-else-if="!openTopServiceSelect">
                <block-hero
                    @service-selected="(service) => this.selectedService = service"
                    @member-selected="(member) => this.selectedMember = member"
                    :provider="provider"
                    :context="context"
                    :compact="true"
                />
                <div class="landing-block" v-for="block in blocks" :key="block.id">
                    <block-text-and-image v-if="isTextAndImage(block.information_block)" :context="context"
                        :providerId="context.providerId" :key="block.id || (new Date()).getTime()" :block="block" />

                    <block-portfolio v-if="isPortfolio(block.information_block)" ref="portfolio" :context="context"
                        :providerId="context.providerId" :key="block.id || (new Date()).getTime()" :block="block" />

                    <block-address v-if="isAddress(block.information_block)" :context="context"
                        :providerId="context.providerId" :key="block.id || (new Date()).getTime()" :block="block" />

                    <block-user-review v-if="isUserReview(block.information_block)" :context="context"
                        :providerId="context.providerId" :key="block.id || (new Date()).getTime()" :block="block" />

                    <block-provider-recommendation v-if="isProviderRecommendation(block.information_block)"
                        :context="context" :providerId="context.providerId" :key="block.id || (new Date()).getTime()"
                        :block="block" />

                    <block-text v-if="isText(block.information_block)" :context="context" :providerId="context.providerId"
                        :key="block.id || (new Date()).getTime()" :block="block" />

                    <block-services v-if="isServices(block.information_block)" :context="context"
                        :providerId="context.providerId" :key="block.id || (new Date()).getTime()" :block="block" />

                    <block-members v-if="isMembers(block.information_block)" :context="context"
                        :providerId="context.providerId" :key="block.id || (new Date()).getTime()" :block="block" />

                    <block-ig v-if="isIG(block.information_block)" :context="context" :providerId="context.providerId"
                        :key="block.id || (new Date()).getTime()" :block="block" />

                    <block-bookable v-if="isBookables(block.information_block)" :context="context"
                        @bookableClick="onBookableSelected" :providerId="context.providerId"
                        :key="block.id || (new Date()).getTime()" :block="block" />

                    <block-youtube v-if="isYoutube(block.information_block)" :context="context"
                        :providerId="context.providerId"
                        :key="block.id || (new Date()).getTime()" :block="block" />
                </div>
            </div>

            <footer v-if="!openTopServiceSelect" class="landing-footer text-center theme-tinted-background">
                <div>
                    <a v-if="provider.facebook_account"
                        class="social-link social-link-light social-link-facebook d-inline-block mt-2 mb-2" target="_blank"
                        :href="'https://facebook.com/' + provider.facebook_account"><i
                            class="fab fa-facebook"></i>{{provider.facebook_account}}</a>
                    <a v-if="provider.twitter_account"
                        class="social-link social-link-light social-link-twitter d-inline-block mt-2 mb-2" target="_blank"
                        :href="'https://twitter.com/' + provider.twitter_account">
                        <img src="/img/icon-x.png" alt="x-icon">
                        {{provider.twitter_account}}</a>
                    <a v-if="provider.instagram_account"
                        class="social-link social-link-light social-link-instagram d-inline-block mt-2 mb-2" target="_blank"
                        :href="'https://instagram.com/' +  provider.instagram_account"><i
                            class="fab fa-instagram"></i>{{provider.instagram_account}}</a>
                    <a v-if="provider.line_id && provider.lineLink"
                        class="social-link social-link-light social-link-line d-inline-block mt-2 mb-2" target="_blank"
                        :href="provider.lineLink">
                        <i class="fab fa-line"></i>{{provider.line_id}}</a>
                    <a v-if="provider.bio_link_value && provider.bio_link_prefix"
                        class="social-link social-link-light social-link-bio-link d-inline-block mt-2 mb-2" target="_blank"
                        :href="provider.bio_link_prefix + provider.bio_link_value">
                        <img :src="bioLinkIcon" alt="bio-link-icon">{{ provider.bio_link_value }}</a>
                </div>
                <div>
                    <span>{{provider.name}}</span>, Powered by <a :href="context.dingUrl" class="footer-ding-link">{{$t('ding_app_name')}}</a>
                </div>
                <div v-if="provider.show_business_entity_info">
                    <small style="font-size: smaller;">
                        {{ $t('information.business_entity_name') + ' ' + provider.business_entity_name }}
                        {{ $t('information.vat_number') + ' ' + provider.vat_number }}
                    </small>
                </div>
            </footer>

            <footer v-if="shouldShowFooter"
                class="booking-footer py-2 d-inline-block d-md-none container-fluid">
                <div class="row">
                    <div v-if="!hasPresetInBookingPass" class="col-12 relative">
                        <available-date-time-picker ref="availableDateTimePickerMobile"
                            :check-cart-items="true"
                            :disabled="!selectedService || !selectedMember"
                            input-class="availability-calendar-input-class" class="flex-grow-1"
                            v-model="selectedDate" :service="selectedService" :member="selectedMember"
                            :fixed-time="selectedService ? selectedService.start_time : null"
                            :provider="provider" :context="context" />
                        <div v-if="!selectedService || !selectedMember" @click="onDatePickerClicked" style="position: absolute;top:0;left:0;right:0;bottom:0;"></div>
                    </div>
                    <div v-if="!hasPresetInBookingPass && selectedService && selectedService.allow_custom_duration && selectedDate" class="col-12 mt-2">
                        <available-date-time-picker
                            ref="availableEndDateTimePickerMobile"
                            :extraAvailabilityCheck="isTimeslotAvailableForEndDate"
                            :check-cart-items="true"
                            :ignore-service-start-time="true"
                            :overwritePlaceholder="$t('message.select_custom', {custom: (provider.landing_choose_end_time_label || $t('general.booking_end_datetime'))})"
                            input-class="availability-calendar-input-class"
                            class="flex-grow-1"
                            v-model="selectedEndDate"
                            :cross-over-disabled="true"
                            :start-moment="selectedDateMoment"
                            :fixed-time="selectedService.custom_duration_fixed_endtime"
                            :service="selectedService"
                            :member="selectedMember"
                            :provider="provider"
                            :context="context" />
                    </div>
                    <div class="col-12 px-3">
                        <button class="btn btn-primary btn-block theme-tinted-background theme-tinted-border btn-check mt-2 font-weight-bold" :class="{disabled: isLoadingQuestions}" :disabled="isLoadingQuestions"
                            @click="attemptSubmit">{{$t('message.submit')}}</button>
                    </div>
                </div>
            </footer>
            <footer v-if="selectedService && isPreviewingService(selectedService)" class="in-preview-booking-footer booking-footer text-center py-2 d-inline-block d-md-none container-fluid">
                {{$t(
                    selectedService?.auto_visible_at
                    ? 'message.is_preview_cant_book_with_schedule' : 'message.is_preview_cant_book', {
                        start: autoVisibleAtFormatted
                    })}}
            </footer>
        </div>
        <div v-if="isPreparing && isAdminOfProvider" class="preparation-hint-container">
            <div>{{ $t('message.preparation_hint') }}</div>
        </div>
        <Interstitial v-if="activeInterstitials.length" :context="context" :interstitials="activeInterstitials" />
    </div>
</template>

<script>
    import { directive as onClickaway } from 'vue-clickaway';
    import availableDateTimePicker from './AvailableDateTimePicker';
    import awareBlockType from '../../mixins/aware-block-type';
    import NewBookingForm from '../booking/NewBookingForm.vue';
    import topServiceSelect from './TopServiceSelect.vue';
    import RootStore from '../../stores/root';
    import { mapActions, mapGetters } from 'vuex';
    import BlockBookable from './BlockBookable.vue';
    import moment from 'moment';
    import 'moment-timezone';
    import promptConfirm from '../../mixins/prompt-confirm';
    import floatingWindow from '../common/FloatingWindow.vue';
    import TopBarCustomerSection from '../common/TopBarCustomerSection.vue';
    import Interstitial from '../interstitial/Interstitial.vue';
    import { EventClickSocialLink } from '../../bu/models/GA4';
    import linkTreeIcon from '../../../images/icon-linkTree.png';
    import FormSectionController from '../common/FormSectionController.vue';
    import LoadingIndicator from '../common/LoadingIndicator.vue';

    export default {
        components: { LoadingIndicator, topServiceSelect, NewBookingForm, availableDateTimePicker, BlockBookable, floatingWindow, TopBarCustomerSection, Interstitial, FormSectionController },
        directives: { onClickaway },
        store: RootStore,
        props: {
            blocks: {required: true,
                type: Array
            },
            context: {
                required: true,
                type: Object
            },
            provider: {
                required: true,
                type: Object
            }
        },
        mixins: [awareBlockType, promptConfirm],
        watch: {
            selectedMember() {
                if (this.hasAttemptedPreselection) {
                    this.updateHistory();
                    this.checkServiceAndMemberValid();
                }
            },
            selectedService() {
                if (this.selectedService) {
                    this.openTopServiceSelect = true;
                    if (this.selectedService) {
                        if (this.selectedService.limited_periods.length === 1) {
                            const limitedPeriod = this.selectedService.limited_periods[0];
                            const periodStart = moment.tz(limitedPeriod.start, 'GMT').tz(this.provider.timezone);
                            const periodEnd = moment.tz(limitedPeriod.end, 'GMT').tz(this.provider.timezone);
                            if (periodStart.isSame(periodEnd, 'day') && this.selectedService.start_time) {
                                const components = this.selectedService.start_time.split(':');
                                const targetMoment = moment(periodStart).hour(components[0]).minute(components[1]);
                                this.selectedDate = new Date(targetMoment.format());
                            }
                        }
                        if (this.selectedDate &&!this.selectedService.allow_custom_duration && this.selectedService.duration_minutes) {
                            const end = moment(this.selectedDate).add(this.selectedService.duration_minutes, 'minutes');
                            this.setCartEnd(end.format('YYYY-MM-DD HH:mm:00'));
                            this.selectedEndDate = end.toDate();
                        }
                    }
                }
                this.updateHistory();
                this.checkServiceAndMemberValid();
                this.$set(this.context, 'selectedService', this.selectedService);
                
            },
            selectedDate() {
                if (this.selectedDate) {
                    const format = 'YYYY-MM-DD HH:mm:00';
                    const startMoment = moment(this.selectedDate);
                    const startMomentString = startMoment.format(format);
                    this.$set(this.context, 'selectedDate', startMomentString);
                    this.setCartStart(startMomentString);
                    if (this.selectedService && !this.selectedService.allow_custom_duration) {
                        const end = moment(startMomentString).add(this.selectedService.duration_minutes, 'minutes');
                        this.setCartEnd(end.format(format));
                    }
                } else {
                    this.$set(this.context, 'selectedDate', null);
                    this.setCartStart(null);
                    this.setCartEnd(null);
                }
                this.$refs['availableEndDateTimePickerMobile']?.clear();
                this.$refs['availableEndDateTimePicker']?.clear();
                this.updateHistory();
            },
            selectedEndDate() {
                if (this.selectedEndDate) {
                    const endMoment = moment(this.selectedEndDate);
                    const endMomentString = endMoment.format('YYYY-MM-DD HH:mm:00');
                    this.$set(this.context, 'selectedEndDate', endMomentString);
                    this.setCartEnd(endMomentString);
                } else {
                    this.$set(this.context, 'selectedEndDate', null);
                    this.setCartEnd(null);
                }
                this.updateHistory();
            }
        },
        computed: {
            ...mapGetters({
                hasInitedCustomer: 'app/hasInitedCustomer',
                customer: 'app/customer',
                interstitials: 'interstitials/interstitials',
                hasPresetInBookingPass: 'cart/hasPresetInBookingPass',
            }),
            shouldShowFooter() {
                if (this.selectedService && !this.isPreviewingService(this.selectedService)) {
                    return true;
                }
                return false;
            },
            startDateTimePickerPlaceholder() {
                if (this.selectedService?.allow_custom_duration) {
                    if (this.provider.landing_choose_time_label) {
                        return this.$t('message.select_custom', {custom: this.provider.landing_choose_time_label});
                    } else {
                        return this.$t('message.select_start_time');
                    }
                } else {
                    if (this.provider.landing_choose_time_label) {
                        return this.$t('message.select_custom', {custom: this.provider.landing_choose_time_label});
                    } else {
                        return null;
                    }
                }
            },
            autoVisibleAtFormatted() {
                if (this.selectedService) {
                    return moment.tz(this.selectedService.auto_visible_at, 'GMT').tz(this.provider.timezone).format('YYYY-MM-DD A h:mm');
                }
                return null;
            },
            selectedDateMoment() {
                if (this.selectedDate) {
                    return moment(this.selectedDate);
                }
                return null;
            },
            hasTopBar() {
                return this.openTopServiceSelect || this.context.logoContentUnit || this.hasLogInEnabled;
            },
            isPreparing() {
                return this.provider.is_preparing;
            },
            isAdminOfProvider() {
                return this.context.isProviderAdmin;
            },
            isUser() {
                return !!this.context.currentUserId;
            },
            hasLogInEnabled() {
                return !!(this.provider.login_setting && this.provider.login_setting.enabled);
            },
            memberForCurrentServices() {
                return this.membersForService(this.selectedService);
            },
            aliveMembers() {
                return this.provider.members.filter((u) => {
                    return !u.pivot.deleted_at && u.services.length > 0 && !u.pivot.is_internal;
                });
            },
            availableServices() {
                const availableServices = this.provider.services.filter((s) => {
                    if (s.archived_at) {
                        return false;
                    }

                    if (s.is_disabled && !s.is_preview) {
                        return false;
                    }

                    let membersForService = this.provider.members.filter((member) => {
                        if (member.pivot.deleted_at || member.pivot.is_internal) {
                            return false;
                        }
                        return member.services.filter((memberService) => {
                            return memberService.id === s.id;
                        }).length > 0;
                    });

                    if (membersForService.length === 0) {
                        return false;
                    }

                    if (s.limited_periods && s.limited_periods.length > 0) {
                        var now = moment();
                        var validPeriods = s.limited_periods.filter((p) => {
                            return moment.tz(p.end, 'GMT').isAfter(now);
                        });
                        if (validPeriods.length === 0) {
                            return false;
                        }
                    }

                    return true;
                });
                return availableServices;
            },
            activeInterstitials() {
                return this.interstitials.filter(i => i.is_enabled).sort((a, b) => a.order - b.order);
            },
            bioLinkIcon() {
                const isLinkTree = this.provider.bio_link_prefix.indexOf('linktr.ee') !== -1
                return isLinkTree ? '/img/icon-linkTree.png' : '';
            },
        },
        data() {
            var preopenedPortfolioAlbum = null;
            let albumMatch = document.location.href.match(/^.*\/i\/([0-9]+)\/a\/([a-z0-9\-\.]+)(\/p\/){0,1}([0-9a-z]+){0,1}/)
            if (albumMatch) {
                preopenedPortfolioAlbum = {
                    portfolioId: albumMatch[1],
                    albumId: albumMatch[2],
                    contentUnitId: albumMatch[4]
                }
            }
            return {
                hasAttemptedPreselection: false,
                preopenedPortfolioAlbum,
                selectedDate: null,
                selectedService: null,
                selectedMember: null,
                openTopServiceSelect: false,
                showCustomerMyBox: false,
                customerMenuAnchorEle: null,
                selectedEndDate: null,
                isLoadingQuestions: false,
                formPaddingTop: '44px'
            }
        },
        async mounted() {
            await this.initCustomer();
            this.getCurrencies();
            this.openAlbumIfNeeded();
            this.getInterstitials();
            window.onpopstate = (event) => {
                if (document.path === '/' || !document.path) {
                    this.selectedService = null;
                    this.openTopServiceSelect = false;
                    this.setQuestionSections([]);
                }
            }

            this.preselectIfPossible();

            this.context.bus.$on('add-to-cart', this.onAddToCart);

            if (this.$refs['topBarContainer']) {
                let resizeTimeout;
                let resizeObserver = new ResizeObserver(entries => {
                    clearTimeout(resizeTimeout);
                    resizeTimeout = setTimeout(() => {
                        const entry = entries[0];
                        const cr = entry.contentRect;
                        this.formPaddingTop = `${cr.height + cr.top + cr.y}px`;
                    }, 100);
                });
                resizeObserver.observe(this.$refs['topBarContainer']);
            }
        },
        beforeDestroy() {
            this.context.bus.$off('add-to-cart', this.onAddToCart);
        },
        methods: {
            ...mapActions({
                initCustomer: 'app/initCustomer',
                getLoggedInCustomer: 'app/getLoggedInCustomer',
                setBookingInStore: 'bookings/setBooking',
                logOutCustomer: 'app/logOutCustomer',
                setCartStart: 'cart/setStart',
                setCartEnd: 'cart/setEnd',
                getInterstitials: 'interstitials/getInterstitials',
                setQuestionSections: 'question-sections/setSections',
                getCurrencies: 'currencies/getCurrencies',
            }),
            onDatePickerClicked() {
                if (!this.selectedService) {
                    this.promptAlert(this.provider.landing_service_label ? this.$t('please_select_custom_first', { custom: this.provider.landing_service_label }) : this.$t('please_select_service_first'), () => {
                        this.$refs['topServiceSelect'].openServiceSelect();
                    });
                    return;
                }
                if (!this.selectedMember) {
                    this.promptAlert(this.provider.landing_member_label ? this.$t('please_select_custom_first', { custom: this.provider.landing_member_label }) : this.$t('please_select_member_first'), () => {
                        this.$refs['topServiceSelect']?.openMemberSelect();
                    });
                    return;
                }
            },
            membersForService(service) {
                return this.aliveMembers.filter((u) => {
                    if (u.pivot.deleted_at || u.pivot.is_internal) {
                        return false;
                    }
                    for (var i in u.services) {
                        const s = u.services[i];
                        if (service && s.id === service.id) {
                            return true;
                        }
                    }
                    return false;
                });
            },
            onMemberSelected(member) {
                this.selectedMember = member
            },
            onToggleIsLoadingQuestions(value) {
                this.isLoadingQuestions = value;
            },
            isPreviewingService(service) {
                return service.is_disabled && service.is_preview;
            },
            isTimeslotAvailableForEndDate(timeSlotMoment) {
                // 1. Cannot be earlier than selected start date time
                if (this.selectedDateMoment.isAfter(timeSlotMoment) || this.selectedDateMoment.isSame(timeSlotMoment)) {
                    return false;
                }
                
                // 2. Cannot not be later than selected start date time + longest day range
                if (this.selectedService.maximum_custom_duration_value > 0) {
                    if (this.selectedService.maximum_custom_duration_unit === 'night') {
                        const refrenceMoment = this.selectedDateMoment.clone().startOf('day');
                        const nights = Math.ceil(timeSlotMoment.diff(refrenceMoment, 'days', true)) - 1;
                        if (nights > this.selectedService.maximum_custom_duration_value) {
                            return false;
                        }
                    } else if (this.selectedService.maximum_custom_duration_unit === 'day') {
                        const refrenceMoment = this.selectedDateMoment.clone().startOf('day');
                        const days = Math.ceil(timeSlotMoment.diff(refrenceMoment, 'days', true));
                        if (days > this.selectedService.maximum_custom_duration_value) {
                            return false;
                        }
                    } else {
                        const duration = timeSlotMoment.diff(this.selectedDateMoment, this.selectedService.maximum_custom_duration_unit, true);
                        if (duration > this.selectedService.maximum_custom_duration_value) {
                            return false;
                        }
                    }
                } 

                // 3. Duration cannot be shorter than minimum duration set
                if (this.selectedService.minimum_custom_duration_unit) {
                    if (this.selectedService.minimum_custom_duration_unit === 'night') {
                        const refrenceMoment = this.selectedDateMoment.clone().startOf('day');
                        const nights = Math.ceil(timeSlotMoment.diff(refrenceMoment, 'days', true)) - 1;
                        if (nights < this.selectedService.minimum_custom_duration_value) {
                            return false;
                        }
                    }  else if (this.selectedService.minimum_custom_duration_unit === 'day') {
                        const refrenceMoment = this.selectedDateMoment.clone().startOf('day');
                        const days = Math.ceil(timeSlotMoment.diff(refrenceMoment, 'days', true));
                        if (days < this.selectedService.minimum_custom_duration_value) {
                            return false;
                        }
                    } else {
                        const duration = timeSlotMoment.diff(this.selectedDateMoment, this.selectedService.minimum_custom_duration_unit, true);
                        if (duration < this.selectedService.minimum_custom_duration_value) {
                            return false;
                        }
                    }
                }

                const dateTimePicker = this.$refs['availableEndDateTimePicker'].$el?.offsetParent ? this.$refs['availableEndDateTimePicker'] : this.$refs['availableEndDateTimePickerMobile'];
                if (dateTimePicker) {
                    const bookingManager = dateTimePicker.bookingManager;
                    const startMoment = moment(this.selectedDate).format('YYYY-MM-DD HH:mm:ss');
                    if (this.selectedService && !bookingManager.isTimeslotCanBeEndTimeslot(this.selectedService, startMoment, timeSlotMoment)) {
                        return false;
                    };
                }

                return true;
            },
            openCustomerProfile() {
                window.document.location = '/me'
            },
            openCustomerMenu() {
                this.customerMenuAnchorEle = this.$refs['customerMenuButton'];
            },
            closeCustomerMenu() {
                this.customerMenuAnchorEle = null;
            },
            openDatePicker() {
                const dateTimePicker = this.$refs['availableDateTimePicker'];
                const dateTimePickerMobile = this.$refs['availableDateTimePickerMobile'];
                if (dateTimePicker.$el.offsetParent) {
                    dateTimePicker.open();
                } else {
                    dateTimePickerMobile.open();
                }
            },
            openEndDatePicker() {
                const dateTimePicker = this.$refs['availableEndDateTimePicker'];
                const dateTimePickerMobile = this.$refs['availableEndDateTimePickerMobile'];
                if (dateTimePicker.$el.offsetParent) {
                    dateTimePicker.open();
                } else {
                    dateTimePickerMobile.open();
                }
            },
            onBookableSelected(bookable) {
                const service = this.provider.services.find((s) => s.id == bookable.service_id);
                // if currently selected member does not provider the selected service, clear selectedMember
                const membersProvidingService = this.membersForService(service);
                if (this.selectedMember && !membersProvidingService.find((m) => m.id == this.selectedMember.id)) {
                    this.selectedMember = null;
                }
                if (!service.archived_at && (!service.is_disabled || service.is_preview)) {
                    this.selectedService = service;
                } else {
                    this.promptAlert(this.provider.landing_service_label ? this.$t('custom_is_not_available', {custom: this.provider.landing_service_label}) : this.$t('service_is_not_available'));
                }
            },
            preselectIfPossible() {
                if (!window.location.search) {
                    this.hasAttemptedPreselection = true;
                    return;
                }

                const urlParams = new URLSearchParams(window.location.search);
                const serviceId = urlParams.get('sid');
                const memberId = urlParams.get('mid');
                const startDate = urlParams.get('date');
                const endDate = urlParams.get('end_date');

                if (serviceId) {
                    this.selectedService = this.availableServices.find((s) => s.id == serviceId);
                    if (!this.selectedService) {
                        this.promptAlert(
                            this.provider.landing_service_label
                                ? this.$t('custom_is_not_available', { custom: this.provider.landing_service_label })
                                : this.$t('service_is_not_available'),
                            () => {
                                window.location = '/';
                            }
                        );
                    }
                }

                if (memberId) {
                    this.selectedMember = this.aliveMembers.find((m) => m.id == memberId);
                    if (!this.selectedMember) {
                        window.alert(
                            this.provider.landing_member_label
                                ? this.$t('custom_is_not_available', { custom: this.provider.landing_member_label })
                                : this.$t('member_is_not_available')
                            );
                        window.location = '/';
                    }
                }

                if (this.selectedService || this.selectedMember) {
                    this.checkServiceAndMemberValidForPreset();
                }

                if (startDate) {
                    const targetMoment = moment(startDate).tz(this.provider.timezone);
                    this.selectedDate = targetMoment.toDate();
                }

                if (endDate) {
                    const targetMoment = moment(endDate).tz(this.provider.timezone);
                    this.selectedEndDate = targetMoment.toDate();
                }

                this.hasAttemptedPreselection = true;
            },
            checkServiceAndMemberValidForPreset() {
                if (this.selectedMember && this.selectedService) {
                    const result = this.memberForCurrentServices.filter((m) => m.id == this.selectedMember.id);
                    if (result.length == 0) {
                        window.alert(this.$t('member_service_not_valid'));
                        window.location = '';
                    }
                }
            },
            checkServiceAndMemberValid() {
                if (this.selectedService && this.selectedMember) {
                    const isValidMember = this.memberForCurrentServices.filter((m) => m.id == this.selectedMember.id).length > 0;
                    if (!isValidMember) {
                        if (this.provider.ask_order === 'ASK_ORDER_SERVICE_FIRST') {
                            this.selectedMember = null;
                        } else {
                            this.selectedService = null;
                        }
                    }
                }
            },
            updateHistory() {
                if (this.selectedService) {
                    const currentSearchParams = new URLSearchParams(window.location.search);
                    let url = '/reserve';
                    const params = {
                        sid: this.selectedService.id,
                    };
                    if (currentSearchParams.get('item_id')) {
                        params.item_id = currentSearchParams.get('item_id');
                    }
                    if (currentSearchParams.get('item_group_id')) {
                        params.item_group_id = currentSearchParams.get('item_group_id');
                    }

                    let isLine = this.isLineBrowser();
                    if (isLine) {
                        params.openExternalBrowser = 1;
                    }

                    if (this.selectedMember) {
                        params.mid = this.selectedMember.id;
                    }

                    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
                    if (this.selectedDate) {
                        params.date = moment(this.selectedDate).format(dateFormat);
                    }
                    if (this.selectedService?.allow_custom_duration && this.selectedDate && this.selectedEndDate) {
                        params.end_date = moment(this.selectedEndDate).format(dateFormat);
                    }

                    const queryString = new URLSearchParams(params).toString();
                    url = url + '?' + queryString;
                    if (window.location.pathname === url) {
                        window.history.replaceState(null, '', url);
                    } else {
                        if (isLine) {
                            window.location = url;
                        } else {
                            window.history.pushState(null, '', url);
                        }
                    }
                } else {
                    window.history.replaceState(null, '', '/');
                }
            },
            isLineBrowser() {
                return navigator.userAgent.indexOf('Line') > -1 || navigator.userAgent.indexOf('line') > -1;
            },
            gaTrackBooked() {
                window.gtag && window.gtag('event', 'book', {
                    'event_category' : 'Provider Performance',
                    'event_label' : this.selectedService.title
                });
            },
            openAlbumIfNeeded() {
                if (this.preopenedPortfolioAlbum) {
                    // clear history stack and portfolio block will set correct history item
                    window.history.replaceState({}, null, '/');

                    this.$nextTick(() => {
                        const $portfolioEl = this.$refs['portfolio'].find((item) => {
                            return item.$props.block.id == this.preopenedPortfolioAlbum.portfolioId
                        });
                        const album = $portfolioEl.albums.find(album => album.meta.id == this.preopenedPortfolioAlbum.albumId);
                        $portfolioEl.openAlbum(
                            this.preopenedPortfolioAlbum.albumId,
                            this.preopenedPortfolioAlbum.contentUnitId,
                            album
                        );
                    });
                }
            },
            attemptSubmit() {
                this.$refs['booking-form'].attemptSubmit();
            },
            onAddToCart(item, spec) {
                if (spec && spec.fixed_date_time) {
                    const targetMoment = moment.tz(spec.fixed_date_time, 'GMT').tz(this.provider.timezone);
                    this.selectedDate = targetMoment.toDate();
                }
            },
            trackClickSocialLink(type) {
                window.tracker.track(() => new EventClickSocialLink(type));
            }
        }
    }
</script>

<style scoped lang="scss">

.logo {
    @media screen and (max-width: 425px) {
        & {
            margin: 0 auto 0 0;
        }
        & img {
            width: 44px;
            height: 44px;
            margin: 0;
        }
    }
}

.booking-footer {
    background: white;
    box-shadow: 0px 0px 4px 0px #444;
    flex-grow: 0;
    z-index: 99;
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
}

.booking-form {
    background: #EAEAEA;
    // overflow: auto;
    padding-bottom: 24px;
    flex-grow:1;
    padding-top: 16px;
    padding-left: 0;
    padding-right: 0;
    @media screen and (max-width: 768px) {
        & {
            margin-bottom: 91px;
        }
    }
}

.slide-up-enter-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
}

.slide-up-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-up-enter-to, .slide-up-leave {
    max-height: 100px;
    overflow: hidden;
}

.slide-up-enter, .slide-up-leave-to {
    overflow: hidden;
    max-height: 0;
}

.top-bar-container /deep/ .field-label {
    font-size: 12px !important;
    font-weight: bold;
    color: #999;
    margin-bottom: 4px;
}

.service-select-hint {
    color: #888;
    align-items: center;
    display: flex;
    justify-content: center;
}

.user-menu-container {
    position: fixed;
    top: 0;
    right: 0;
    padding: 6px 12px;
    border-bottom-left-radius: 3px;
    user-select: none;
    z-index: 200;
    display: flex;
    align-items: center;

    a:not(:first-child) {
        margin-left: 8px;
    }

    a:hover {
        font-weight: bold;;
    }
}

.top-service-select {
    margin-top: 4px;
}

.preparing-page-container {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    
    p {
        text-align: center;
        margin: 0;
        font-size: 20px;

    }
}

.preparing-page-logo {
    max-width: 160px;
    
    img {
        width: 100%;
    }
}

.in-preview-booking-footer {
    font-size: 18px;
    color: #414141;
}

.preparation-hint-container {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    background-color: #fff;
    color: #6c757d;
    z-index: 2147483647;
    padding: 16px;
    display: flex;
    align-content: center;
    justify-content: center;
    box-shadow: 0px 2px 6px #eee;
}

</style>

<i18n>
{
    "en": {
        "login_or_register": "Sign In/Register",
        "login": "Sign In",
        "my_bookings": "我的預約",
        "logout": "Logout",
        "service_is_not_available": "Service is not available.",
        "member_is_not_available": "Member is not available.",
        "member_service_not_valid": "Invalid booking content",
        "custom_is_not_available": "{custom} is not available.",
        "please_select_member_first": "Please select staff first",
        "please_select_service_first": "Please select service first",
        "please_select_custom_first": "Please select {custom} first"
    },
    "zh": {
        "login_or_register": "登入/註冊",
        "login": "登入",
        "my_bookings": "我的預約",
        "logout": "登出",
        "service_is_not_available": "目前不接受預約",
        "member_is_not_available": "人員無法提供服務",
        "member_service_not_valid": "無效的預約內容",
        "custom_is_not_available": "{custom}目前無法預約",
        "please_select_member_first": "請選擇服務人員",
        "please_select_service_first": "請選擇服務",
        "please_select_custom_first": "請先選擇{custom}"
    }
}
</i18n>
